import * as React from 'react';
import Page from '../Page';
import AfrSummaryCore from '../AfrCore/AfrSummaryCore';
import { UserRoleEnum } from '../../redux/UserSlice';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';




const CourtReporting939AdminA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <Page>
                <AfrSummaryCore userRole={isAdminUser ? UserRoleEnum.Admin : UserRoleEnum.EntityUser} dataSection="Admin" />
            </Page>
        </React.Fragment>
    );
}

export default CourtReporting939AdminA;